/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class AgendaSection extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-5-et block-4 z-20">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-62 white-text bold-text text-uppercase">The<br/><span className="f-100 ls-5">Experience</span><br/>Agenda</h1>
                            </div>
                        </div>
                        <div className="row white z-depth-5">
                            <div className="row m0 p-20-all brand-blue-5">
                                <div className="col s12 p0 left-align">
                                    <h1 className="f-38 ls-3 brand-text bold-text text-uppercase mb0">Day 1:<br/></h1>
                                    <h1 className="f-22 white-text text-normal text-uppercase mb0">Take Ownership Of Life<br/></h1>
                                    <h1 className="f-22 white-text bold-text text-uppercase">Saturday, December 9th</h1>
                                </div>
                            </div>
                            <div className="row m0">
                                <div className="col s12 m12 left-align">
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 m3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">6:30am:</p></div>
                                        <div className="col s9 m9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">VIP Check In @ ‘Gym’</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">7:00am - 8:00am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Morning Routine for a Peak State With VIP ticket holders With Brian Mazza</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">8:30am - 9:15am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align p0">General Admission Check In & Networking</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">9:30am - 10:15am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align p0">Becoming a Phenomenon With Eric Thomas</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10:15am - 11:00am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align p0">The 8 Laws Of Leadership With Gerard Adams</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11:00am - 11:45am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align p0">Knowing Yourself - How to Rise Above The Noise As An Entrepreneur With Peter Voogd</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11:45am - 12:30pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align p0">NeuroHacking To Become Your Greatest Self With Monica Adams</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">12:30pm - 1:30pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Lunch</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1:45am - 2:30am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align p0">Trying Vs. Execution With Eric Thomas</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2:30pm - 3:15pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Wantrapreneurs Vs. Entrepreneurs With Gerard Adams</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3:15 pm - 4:00 pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Mastering Your Small Or Big Business With Josh Hatch</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row white z-depth-5">
                            <div className="row m0">
                                <div className="row m0 p-20-all brand-blue-5">
                                    <div className="col s12 p0 left-align">
                                        <h1 className="f-38 ls-3 brand-text bold-text text-uppercase mb0">DAY 2:<br/></h1>
                                        <h1 className="f-22 white-text text-normal text-uppercase mb0">Take Ownership Of Your Business<br/></h1>
                                        <h1 className="f-22 white-text bold-text text-uppercase">Sunday, December 10th</h1>
                                    </div>
                                </div>
                            </div>
                            <div className="row m0">
                                <div className="col s12 m12 left-align">
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 m3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">8:30am - 9:15am:</p></div>
                                        <div className="col s9 m9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Check In & Refreshments</p>
                                        </div>
                                    </div>
                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">9:30am - 10:15am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Be Possessed With The Dream With Eric Thomas</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">10:15am - 11:00am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Building A Superior Product & Inferior Branding With Eric Thomas Team</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11:00am - 11:45am:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Organic vs Paid Marketing Tactics With Ashley Cline & Justin Belleme</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">11:45am - 12:30pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Live Hot Seats For Your Life & Business With Gerard Adams & Eric Thomas</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 pb-8 text-uppercase bold-text">12:30pm - 1:15pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 pb-8 text-uppercase left-align">Lunch</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">1:30pm - 2:15pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Mastering Lead Generation & Building A High Converting Funnel With Daniel DiPiazza</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">2:15pm - 3:00pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Becoming An Expert In Facebook & Instagram Ad Campaigns With Ashley Cline</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3:00pm - 3:30pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Next Level Content Marketing Strategies With Gerard Adams</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">3:30pm - 4:00pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Question & Answer With Full Speaker Panel</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">4:00pm - 4:30pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">Photographs</p>
                                        </div>
                                    </div>

                                    <div className="row mb0 grey-border-bottom p-20-all">
                                        <div className="col s3 left-align p0"><p className="black-text f-18-agenda m0 p0 text-uppercase bold-text">5:00pm:</p></div>
                                        <div className="col s9 left-align">
                                            <p className="black-text f-18-agenda m0 p0 text-uppercase left-align">After Mastermind Get Together At The Ainsworth In Newark, NJ</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br/>
                    </div>
                </div>
            </div>
        )

    }

}

export default AgendaSection;


// WEBPACK FOOTER //
// ./src/components/agenda-section.js